export const messages = {
  en: {
    reserveOrder: {
      diningOrder: 'Dining Order',
      serviceOrder: 'Service Order',
      searchCondition: 'Search Condition',
      selectAppointmentTime: 'Select Appointment Time',
      selectAppointmentPerson: 'Select Appointment Person',
      selectAppointmentPhone: 'Select Appointment Phone',
      selectStatus: 'Select Status',
      allStatus: 'All Status',
      successStatus: 'Success',
      failStatus: 'Failed',
      waitAuditStatus: 'Wait Audit',
      waitPayStatus: 'Wait Pay',
      inputName: 'Input Name',
      orderId: 'Order ID',
      goodsName: 'Goods Name',
      appointmentPerson: 'Appointment Person',
      appointmentPhone: 'Appointment Phone',
      appointmentDate: 'Appointment Date',
      appointmentTime: 'Appointment Time',
      hour: 'hour',
      unit: 'unit',
      receivableAmount: 'Receivable Amount',
      receivedAmount: 'Received Amount',
      payWay: 'Pay Way',
      status: 'Status',
      createTime: 'Create Time',
      remark: 'Remark',
      cancelAppointment: 'Cancel Appointment',
      confirmCancel: 'Confirm to cancel this appointment?',
      cancelSuccess: 'Cancel success',
      cancelError: 'Cancel failed',
      fetchError: 'Fetch data failed'
    }
  },
  zh: {
    reserveOrder: {
      diningOrder: '就餐订单',
      serviceOrder: '服务订单',
      searchCondition: '查询条件',
      selectAppointmentTime: '请选择预约时间',
      selectAppointmentPerson: '请选择预约人',
      selectAppointmentPhone: '请选择预约电话',
      selectStatus: '请选择状态',
      allStatus: '全部状态',
      successStatus: '预约成功',
      failStatus: '预约失败',
      waitAuditStatus: '待审核',
      waitPayStatus: '待支付',
      inputName: '请输入名称',
      orderId: '订单编号',
      goodsName: '名称',
      appointmentPerson: '预约人',
      appointmentPhone: '预约电话',
      appointmentDate: '预约日期',
      appointmentTime: '预约时间',
      hour: '时',
      unit: '个',
      receivableAmount: '应收金额',
      receivedAmount: '实收金额',
      payWay: '支付方式',
      status: '状态',
      createTime: '预约时间',
      remark: '备注',
      cancelAppointment: '取消预约',
      confirmCancel: '确定要取消此预约吗？',
      cancelSuccess: '取消成功',
      cancelError: '取消失败',
      fetchError: '获取数据失败'
    }
  }
}